export const UPGRADE_MODAL_STEP_AMOUNT = 'stepAmount';
export const INITIAL_OPEN_UPGRADE_CARD = 'initialOpenUpgradeCard';
export const REDIRECT_FROM_TRIAL_MODAL = 'redirectFromTrialModal';
